import { useState, useRef } from 'react';
import HeaderSection from '../../components/HeaderSection/HeaderSection';
import BottomSection from '../../components/BottomSection/BottomSection';
import { useTheme } from '../../context/ThemeContext';





const JpegToBmpConverter = () => {
  const [originalImage, setOriginalImage] = useState(null);
  const { darkMode } = useTheme();
  const [bmpImage, setBmpImage] = useState(null);
  const [isConverting, setIsConverting] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Check if the file is a JPEG
    if (!file.type.match('image/jpeg')) {
        alert('Please upload a JPEG image');
        return;
      }
      

    setIsConverting(true);
    setBmpImage(null);

    const reader = new FileReader();
    reader.onload = (event) => {
      setOriginalImage(event.target.result);
      convertToBmp(event.target.result);
    };
    reader.readAsDataURL(file);
  };

  const convertToBmp = (imageData) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      
      // Draw the image on canvas
      ctx.drawImage(img, 0, 0);
      
      // Convert canvas to BMP
      canvas.toBlob((blob) => {
        const bmpUrl = URL.createObjectURL(blob);
        setBmpImage(bmpUrl);
        setIsConverting(false);
      }, 'image/bmp');
    };
    img.src = imageData;
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = bmpImage;
    link.download = 'converted.bmp';
    link.click();
  };

  const resetConverter = () => {
    setOriginalImage(null);
    setBmpImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <>
    <HeaderSection toolId="jpgToBmp" />
    <div className="min-h-screen bg-gray-50 dark:bg-gray-800 dark:bg-gray-900 dark:bg-gray-800 dark:bg-gray-900 dark:bg-gray-800 dark:bg-gray-900 dark:bg-gray-800 dark:bg-gray-900 dark:bg-gray-800 dark:bg-gray-900 dark:bg-gray-800 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md mx-auto bg-white dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 rounded-xl shadow-md dark:shadow-gray-900/20 dark:shadow-gray-900/20 dark:shadow-gray-900/20 dark:shadow-gray-900/20 dark:shadow-gray-900/20 dark:shadow-gray-900/20 overflow-hidden md:max-w-2xl">
        <div className="p-8">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-gray-800">JPEG to BMP Converter</h1>
            <p className="mt-2 text-sm text-gray-600">Convert your JPEG images to BMP format in your browser</p>
          </div>

          <div className="space-y-6">
            <div className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-lg p-6">
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                accept="image/jpeg"
                className="hidden"
              />
              <button
                onClick={() => fileInputRef.current.click()}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Select JPEG File
              </button>
              <p className="mt-2 text-sm text-gray-500">or drag and drop a JPEG file here</p>
            </div>

            {isConverting && (
              <div className="flex justify-center items-center py-4">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                <span className="ml-3">Converting to BMP...</span>
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {originalImage && (
                <div className="border rounded-lg p-4">
                  <h2 className="text-lg font-medium text-gray-700 dark:text-white dark:text-white dark:text-white dark:text-white dark:text-gray-200 dark:text-gray-200 mb-2">Original JPEG</h2>
                  <img 
                    src={originalImage} 
                    alt="Original JPEG" 
                    className="max-w-full h-auto rounded" 
                  />
                  <p className="mt-2 text-xs text-gray-500">
                    {originalImage.length > 1000000 
                      ? `${Math.round(originalImage.length / 1000000)} MB` 
                      : `${Math.round(originalImage.length / 1000)} KB`}
                  </p>
                </div>
              )}

              {bmpImage && (
                <div className="border rounded-lg p-4">
                  <h2 className="text-lg font-medium text-gray-700 dark:text-white dark:text-white dark:text-white dark:text-white dark:text-gray-200 dark:text-gray-200 mb-2">Converted BMP</h2>
                  <img 
                    src={bmpImage} 
                    alt="Converted BMP" 
                    className="max-w-full h-auto rounded" 
                  />
                  <div className="mt-3 flex justify-between">
                    <button
                      onClick={handleDownload}
                      className="px-3 py-1 bg-green-600 text-white rounded-md hover:bg-green-700 text-sm"
                    >
                      Download BMP
                    </button>
                    <button
                      onClick={resetConverter}
                      className="px-3 py-1 bg-gray-200 text-gray-700 dark:text-white dark:text-white dark:text-white dark:text-white dark:text-gray-200 dark:text-gray-200 rounded-md hover:bg-gray-300 text-sm"
                    >
                      Convert Another
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
    <BottomSection toolId="jpgToBmp" />
    </>
  );
};

export default JpegToBmpConverter;